/**
 * PERSON CHANNEL API — Wrapper REST per la lookup PersonChannel (read-only).
 *
 * Clone esatto di personSourceApi. Contratto backend (rest-openapi.yaml):
 *   - GET /people/{groupId}/channels   pagination server-side -> Page<PersonChannel>
 *     Query params: page (1-based, default 1), pageSize (default 20),
 *                   sort (es. "name:asc"), search (substring case-insensitive).
 *
 * Il backend NON espone CRUD su PersonChannel — la creazione avviene
 * implicitamente server-side via find-or-create quando PersonInput arriva
 * con `personChannel` valorizzato (vedi PersonChannelLocalService).
 */

import type { Page, ServerListParams } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import type { PersonChannel } from './personChannelTypes';

const PEOPLE = '/people';

export const personChannelApi = {
  getAll: (groupId: number, params?: ServerListParams): Promise<Page<PersonChannel>> =>
    httpClient
      .get<Page<PersonChannel>>(`${PEOPLE}/${groupId}/channels`, {
        params: params as Record<string, unknown> | undefined,
      })
      .then((r) => r.data),
};
